export default (value: any): value is Function => typeof value === 'function';
